import ReactDOM from 'react-dom/client';
import { Suspense, StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import App from './app';
import ErrorBoundary from './components/ErrorBoundary';
import { logError } from './services/errorLogger';
import { endpoints } from './utils/axios';

window.addEventListener('error', (event) => {
  if (!event.error && !event.message) return;

  logError(
    {
      type: 'javascript_error',
      message: event.error?.message || event.message || 'Unknown JavaScript error',
      stack_trace: event.error?.stack || '',
      meta: {
        source: event.filename || '',
        line: event.lineno,
        column: event.colno,
      },
    },
    endpoints.system_errors
  );
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;

  logError(
    {
      type: 'unhandled_promise',
      message: reason?.message || String(reason),
      stack_trace: reason?.stack || '',
      meta: { reason: reason?.message || String(reason) },
    },
    endpoints.system_errors
  );
});

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <StrictMode>
    <ErrorBoundary>
      <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA}>
        <HelmetProvider>
          <BrowserRouter>
            <Suspense>
              <App />
            </Suspense>
          </BrowserRouter>
        </HelmetProvider>
      </GoogleReCaptchaProvider>
    </ErrorBoundary>
  </StrictMode>
);
